import {Component, OnInit, OnDestroy, AfterViewInit, ViewChildren, QueryList} from '@angular/core';
import {Router, Params, ActivatedRoute} from "@angular/router";
import {Location} from '@angular/common';
import {MachineService} from "../../services/machine.service";
import {Machine} from "../../models/machine";
import {HttpService} from "../../services/http.service";
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {HubModule} from "../../models/hub-module";
import {UserService} from "../../services/user.service";
import {AccountService} from "../../services/account.service";
import {Account} from "../../models/account";
import { environment } from '../../../environments/environment';
import { TabsetComponent, TabDirective } from 'ngx-bootstrap';

@Component({
    moduleId: module.id,
    selector: 'machine-edit',
    templateUrl: 'machine-edit.html',
    styleUrls: ['machine-edit.scss']
})

export class MachineEditComponent implements OnInit {
    private modalHide = [true];
    maxCapsuleOptions = [0,1,2,3,4,5,6,7,8,9,10];
    slotStatusOptions = ["Available", "Empty"];
    vendableHubs = [];
    privOptions = ["owner", "tech", "employee"];
    machine: Machine;
    slotImageUrl = '';
    slotImages = [];
    slotMeta = {};
    assignedUsers = [];
    vendItem: string = "";
    imageChooserSlot = false;
    editingHours = false;
    accountRole;
    accounts;
    account: Account;
    selectedAccount: Account;
    times = ["00:00", "01:00",'02:00', "03:00",'04:00', "05:00",'06:00', "07:00",'08:00', "09:00",'10:00', "11:00",'12:00', "13:00",'14:00', "15:00",'16:00',
        "17:00",'18:00', "19:00",'20:00', "21:00",'22:00', "23:00", "23:59"];
    refreshingDiagnostics = false;
    private deletingPicture = null;
    private deletingMachine = null;
    hubModuleState = {};

    private urlTab: string;
    private tabMap = {
        'general': 0,
        'prizes':1,
        'diagnostics': 2,
        'users': 3,
        'activity': 4
    };

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private machineService: MachineService,
        private httpService: HttpService,
        private userService: UserService,
        private accountService: AccountService,
        private location: Location
    ) {}


    ngOnInit(): void {
        let self = this;

        this.urlTab = this.route.snapshot.params.tab;
        console.log('url tab is', this.urlTab);

        this.machineService.get(this.route.snapshot.params.id)
            .then(machine => {
                self.machine = machine;

                this.accountService.getAccount(self.machine.accountId).then(account => {
                    self.account = account;
                    self.selectedAccount = account;
                });

                this.accountRole = self.userService.accountRole;
                if (self.accountRole === 'accountAdmin') {
                    self.accountService.getAccounts().then(accounts => {
                        self.accounts = accounts;
                    });
                }

                this.machineService.getAssignedUsers(self.route.snapshot.params.id)
                    .then(result => {
                        self.assignedUsers = result;

                        self.refreshHubModules();
                    });

                self.slotMeta = {};
            });
    }

    // ngOnDestroy() {
    //     this.tabSub.unsubscribe();
    //     // this.tabsetSub.unsubscribe();
    // }

    // ngAfterViewInit() {

        // this.tabsetSub = this.tabsets.changes.subscribe((tabsets: QueryList<TabsetComponent>) => {
        //     console.log('tabsets changed')
        //     this.tabset = tabsets.first;
        //     if (this.tabset && this.urlTab) {
        //         let index = this.tabMap[this.urlTab];
        //         if (index >= 0 && index < this.tabset.tabs.length) {
        //             this.tabset.tabs[index].active = true;
        //         }
        //     }
        // });
    // }

    onTabSelect(tab: TabDirective) {
        // update URL
        if (this.urlTab !== tab.heading.toLowerCase()) {
            console.log('onTabSelect:', this.route.url, 'tab:', tab.heading)
            this.urlTab = tab.heading.toLowerCase();
            const url = this.router.createUrlTree([`../${this.urlTab}`], { relativeTo: this.route }).toString();
            this.location.go(url);
        }
    }

    isAdmin() : boolean {
        return this.userService.isSuper;
    }

    initHubModuleState(hubModules) {
        if (hubModules && hubModules.length) {
            for (let hub of hubModules) {
                if (!this.hubModuleState[hub.id]) {
                    this.hubModuleState[hub.id] = { isOpen: false };
                }

            }
        }
    }

    refreshHubModules(): void {
        let self = this;

        if (self.machine.hubModules) {
            for (let hub of self.machine.hubModules) {
                self.hubModuleState[hub.id].refreshing = true;
            }
        }

        this.machineService.getHubModules(self.machine.id).then(hubModules => {
            self.machine.hubModules = hubModules;
            self.machine.hubModules.sort(self.sortByName);
            self.initHubModuleState(self.machine.hubModules);
            for(let hub of hubModules) {
                self.addVendable();
                self.machineService.getPrizes(hub.id)
                    .then(prizes => {
                        hub.slots = prizes;
                        prizes.forEach(function(prizeSlot) {
                            if (!prizeSlot.image || prizeSlot.image == "") {
                                self.slotMeta[prizeSlot.id] = {
                                    editing: false,
                                    imageUrl: self.httpService.getUrl(`/FileStorage/${environment.defaultImageBucket}/download/defaults` + encodeURIComponent('/' +prizeSlot.name) + '.jpg')
                                };
                            } else {
                                self.slotMeta[prizeSlot.id] = {
                                    editing: false,
                                    imageUrl: self.httpService.getUrl(`/FileStorage/${prizeSlot.container}/download/${prizeSlot.image}`)
                                };
                            }
                        });

                        if (self.machine.hubModules) {
                            for (let hub of self.machine.hubModules) {
                                self.hubModuleState[hub.id].refreshing = false;
                            }
                        }
                    });
            }
        });
    }

    addVendable () {
        this.vendableHubs = [];
        for(let hub of this.machine.hubModules) {
            if (hub.enabled) {
                this.vendableHubs.push(hub);
            }
        }
    }

    saveHours() {
        this.machineService.update(this.machine)
            .then(response => {
                this.editingHours = false;
            })
    }


    sortByName(a,b) {
        if (a.type < b.type)
            return -1;
        if (a.type> b.type)
            return 1;
        return 0;
    }

    save(machine): void {
        this.machine.macAddress = this.machine.serialNumber.replace(/\./g, ":");
        this.machineService.update(machine)
            .then(response => {
                this.router.navigate(['/machines'])
            })
    }

    checkImageDemensions(file, cb) {
        let image = new Image();

        image.src = window.URL.createObjectURL(file);

        image.onload = function() {
            cb(image.naturalWidth > 590 || image.naturalHeight > 590);
        }
    }

    normalizeHubType(type) {
        return type === 'lockerxl' ? 'locker XL' : type
    }

    fileUpload(event, slot) {
        let fileList: FileList = event.target.files;
        let self = this;
        if (fileList.length > 0) {
            let file: File = fileList[0];
            this.checkImageDemensions(file, isTooBig => {
                if (isTooBig == false ) {
                    if (file.size < 690000 && (file.type == "image/jpeg" || file.type == "image/png")) {
                        let formData:FormData = new FormData();
                        formData.append('uploadFile', file, file.name);
                        this.slotMeta[slot.id].uploading = true;
                        this.httpService.postImage(`/FileStorage/${this.userService.accountBucketName}/upload`, formData)
                            .then(response => {
                                slot.image = response.name;
                                slot.container = response.container;
                                this.machineService.updateSlotImage(slot)
                                    .then(responseSlot => {
                                        self.slotMeta[slot.id].uploading = false;
                                        self.slotMeta[slot.id].editing = false;
                                        self.slotMeta[slot.id].imageUrl = this.httpService.getUrl(`/FileStorage/${responseSlot.container}/download/${responseSlot.image}`);
                                        self.toastr.success(`Slot ${slot.name} image successfully changed.`);
                                    })
                                    .catch(err => {
                                        self.slotMeta[slot.id].uploading = false;
                                    });
                            })
                            .catch(err => {
                                self.toastr.error("Couldn't send image to server. Contact administrator or try again")
                            });
                    } else {
                        this.toastr.error("File must be either PNG or JPEG and be less than 590kb in file size")
                    }
                } else {
                    this.toastr.error("File cannot exceed 590x590")
                }
            });
        } else {
            this.toastr.error("No File Found - Please try again")
        }
    }

    resetPicture(slot) {
        let that = this;
        slot.image = '';
        that.slotMeta[slot.id] = {
            editing: false,
            imageUrl: that.httpService.getUrl(`/FileStorage/${environment.defaultImageBucket}/download/defaults` + encodeURIComponent('/' +slot.name) + '.jpg')
        };

        setTimeout(function(){ that.saveSlot(slot); }, 10);
    }

    getPictures(slot, modal) {
        this.refreshPictures()
            .then(response => {
                this.imageChooserSlot = slot;
                this.openModal(modal)
            })

    }

    refreshPictures() {
        return this.machineService.getSlotImages()
            .then(response => {
                this.slotImages = response;
                return response;
            });
    }

    resetDiagnosticState(modal) {
        var self = this;
        this.refreshingDiagnostics = true;
        this.machine.diagnosticState = 'none';
        this.machineService.update(this.machine)
        .then(response => {
            self.refreshingDiagnostics = false;
            modal.hide();
        })
        .catch (err => {
            console.log(err)
            self.refreshingDiagnostics = false;
            modal.hide();
        })
    }

    openModal(modal) {
        modal.show();
    }

    getSyncColor(slot) {
        if (slot.syncState == 'ok') {
            return 'green'
        } else if (slot.syncState == 'pending') {
            return 'darkgoldenrod'
        } else {
            return 'red'
        }
    }

    getQuantityColor(slot) {
        if (slot.remainingQuantity > slot.lowQuantityThreshold) {
            return 'green'
        } else if (slot.remainingQuantity >= slot.lowQuantityThreshold && slot.remainingQuantity > 0) {
            return 'darkgoldenrod'
        } else {
            return 'red'
        }
    }

    modifyQuantity(slot, num) {
        if (slot.maxQuantity >= num && num >= 0) {
            slot.remainingQuantity = num;
            let slotData = {remainingQuantity: slot.remainingQuantity};
            this.machineService.updateSlotAttribute(slot.id, slotData).then( () => {
                this.toastr.success("Slot Quantity Updated")
            });
        } else if (num < 0) {
            this.toastr.error("Quantity can't go lower")
        } else {
            this.toastr.error("Max Quantity Already Met")
        }
    }

    updateTicketValue(slot) {
        let slotData = {ticketValue: slot.ticketValue};
        this.machineService.updateSlotAttribute(slot.id, slotData).then( () => {
            this.toastr.success("Slot Ticket Value Updated")
        });
    }

    getSyncIcon(slot) {
        if (slot.syncState == 'ok') {
            return 'check_circle'
        } else if (slot.syncState == 'pending') {
            return 'autorenew'
        } else {
            return 'not_interested'
        }
    }

    spin(slot) {
        if (slot.syncState == 'pending') {
            return 'spin material-icons'
        } else {
            return 'material-icons'
        }
    }

    testPrint(machine): void {
        let self = this;
        machine.diagnosticState = 'print';
        this.machineService.update(machine)
        .then(response => {
            self.machine= new Machine().fromJson(response);
            self.refreshHubModules();
        });
    }

    vendTest(machine): void {
        let self = this;
        machine.diagnosticState = this.vendItem;
        this.machineService.update(machine)
        .then(response => {
            self.machine = new Machine().fromJson(response);
            self.refreshHubModules();
        });
    }

    openSlotEdit(slot): void {
        let self = this;

        let meta = this.slotMeta[slot.id];
        if (!slot.image || slot.image == "") {
            meta.imageUrl = self.httpService.getUrl(`/FileStorage/${environment.defaultImageBucket}/download/defaults` + encodeURIComponent('/' + slot.name) + '.jpg')
        } else {
            meta.imageUrl =  self.httpService.getUrl(`/FileStorage/${slot.container}/download/${slot.image}`)
        }
        meta.editing = true;
    }

    saveSlot(slot): void {
        let self = this;
        this.machineService.saveSlot(slot)
            .then(response => {
                if (response) {
                    self.slotMeta[slot.id].editing = false;
                    self.toastr.success("Prize slot saved successfully", "Success", {toastLife: 2000});
                    slot = response;
                    return true
                }
            })
            .catch(err => {
                self.toastr.error("Couldn't save prize slot");
                return false
            });
    }

    editSlotImage(slot, picture, modal): void {
        let self = this;
        slot.image = picture.name;
        self.slotMeta[slot.id].uploading = true;
        slot.container = picture.container;
        this.machineService.updateSlotImage(slot)
            .then(response => {
                self.slotMeta[slot.id].editing = false;
                self.slotMeta[slot.id].uploading = false;
                self.slotMeta[slot.id].imageUrl = this.httpService.getUrl(`/FileStorage/${slot.container}/download/${slot.image}`);
                self.imageChooserSlot = false;
                slot = response;
                modal.hide();
                self.toastr.success(`Slot ${slot.name} image successfully changed.`);
            })
            .catch(err => {
                self.slotMeta[slot.id].uploading = false;
            });
    }

    confirmDeleteImage(event, picture, modal): void {
        this.deletingPicture = picture;
        modal.show();
        event.stopPropagation();
    }

    deleteSelectedPicture(modal): void {
        let self = this;
        this.machineService.deleteSlotImage(this.deletingPicture)
        .then((result) => {
            if (result === true || result.status === 200) {
                self.toastr.success(`Image successfully deleted`);
            }
            for(let i = 0; i < this.slotImages.length; i++) {
               if (this.slotImages[i].imageUrl === this.deletingPicture.imageUrl) {
                   this.slotImages.splice(i, 1);
                   break;
               }
            }
            this.deletingPicture = null;
            modal.hide();
        });
    }

    confirmDeleteMachine(event, machine, modal): void {
        if (this.isAdmin()) {
            this.deletingMachine = machine;
            modal.show();
            event.stopPropagation();
        }
    }

    deleteMachine(modal): void {
        if (this.isAdmin()) {
            const self = this;
            this.machineService.deleteMachine(this.deletingMachine)
            .then(result => {
                if (result === true) {
                    self.toastr.success(`Machine ${this.deletingMachine.name} successfully deleted`);
                    this.deletingMachine = null;
                    modal.hide();
                    this.router.navigate(['/machines'])
                } else {
                    self.toastr.error(`Unable to delete machine ${this.deleteMachine.name}`);
                }
            });
        }
    }

    saveHub(hub) {
        let self = this;
        this.machineService.saveHub(hub).then(OP => {
            self.toastr.success("Hub successfully saved");
            this.addVendable();
        }).catch((err) => {
            self.toastr.error("Hub save failure")
        })
    }

    createModule(type, modal) {
        let self = this;
        if (this.machineService.validateCanAddModule(this.machine, type)) {
            let module = new HubModule().fromJson({
                type: type,
                enabled: false,
                machineId: this.machine.id
            });

            this.machineService.addModule(this.machine.id, module)
                .then(response => {
                    self.machine.hubModules.push(response);
                    self.initHubModuleState(self.machine.hubModules);
                    self.ngOnInit();
                    modal.hide();
                })
                .catch(err =>{
                    this.toastr.error("Unable to add module: " + err)
                })
        } else {
            this.toastr.error("This machine already has the maximum number of " + type + " modules allowed.");
        }
    }

    edit(person): void {
        person.isEditing = true;
    }

    saveUserEdit(user): void {
        delete user.isEditing;
        this.machineService.updateMachineAssignment(user)
    }


    resetAll(): void {
        this.machineService.restock(this.machine.id)
            .then(result => {
                this.ngOnInit();
                this.toastr.success("All machine slots have been restocked.");
            })
    }

    changeAccount(machine): void {
        machine.accountId = this.selectedAccount.id;
        this.save(machine);
    }

    getAccountName(machine: Machine): String {
        if (!this.accountService.accountMap) {
            return '';
        }
        return this.accountService.accountMap[machine.accountId].name;
    }

    refreshDiagnosticState() {
        var self = this;
        this.refreshingDiagnostics = true;
        this.machineService.get(this.machine.id)
        .then(machine => {
            this.machine.diagnosticState = machine.diagnosticState;
            self.refreshingDiagnostics = false;
        })
        .catch(err => {
            self.refreshingDiagnostics = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/machine-edit/machine-edit.component.ts